import { useEffect, useState } from "react";
import { useTandaTerima } from "../../../Context/TandaTerimaContext";

const LocationColumn = ({ latitude, longitude }) => {
  const tandaTerimaAPI = useTandaTerima();
  const [locationDetails, setLocationDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!latitude || !longitude) {
      setIsLoading(false);
      return;
    }

    const getLocation = async () => {
      try {
        setIsLoading(false);
        
        const details = await tandaTerimaAPI.getLocationFromCoords(latitude, longitude);
        setLocationDetails(details);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    getLocation();
  }, [latitude, longitude]);

  if (!latitude || !longitude) return "-";

  return (
    <a
      href={locationDetails?.url || `https://maps.google.com/?q=${latitude},${longitude}`}
      target="_blank"
      rel="noopener noreferrer" 
      className="text-blue-600 hover:text-blue-800 underline"
    >
      {locationDetails?.city && locationDetails?.province
        ? `${locationDetails.city}, ${locationDetails.province}`
        : `${latitude}, ${longitude}`} 
    </a>
  );
};

export default LocationColumn;
